import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from '../services/auth.service';
import { Router } from '@angular/router';
import { LoginStatus } from 'app/clases/login-status';
@Injectable({
  providedIn: 'root'
})

export class LoginGuard implements CanActivate {
  constructor(private auth:AuthService,private router:Router){}
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot)
    {
      //console.log("hola")
    // if(this.auth.logged)return true;
    // let data = await this.auth.loginStatus();
    // console.log(data)
    // if (!data.sesion_iniciada){
    //     this.router.navigate(['/']);
    //     return false;
    //   }
      return true;
    }
  
}
